export default __webpack_public_path__ + "static/media/clock.6ea7f25b.svg";